import { createAction, props } from '@ngrx/store';
import { CardModel } from '../../../core/models/payment.model';
import { IAddCardResponse } from '../models/add-card.model';

export const loadAddCards = createAction('[AddCard] Load AddCards', props<{ businessId: string; request: CardModel }>());

export const loadAddCardsSuccess = createAction('[AddCard] Load AddCards Success', props<{ response: IAddCardResponse }>());

export const loadAddCardsFailure = createAction('[AddCard] Load AddCards Failure', props<{ error: Error | any }>());
